<template>
  <div class="investors-fs">
    <p class="indent">АЛКОМЕТ АД е публична компания, чиито акции се търгуват на Българската фондова борса. Съгласно
      Закона за публичното предлагане на ценни книжа компанията редовно разкрива финансова и друга информация пред
      Комисията за финансов надзор, към Българската фондова борса и пред обществеността.</p>
    <p class="indent">Тримесечните и годишни финансови отчети се изготвят в съответствие с международните счетоводни
      стандарти и заверяват от независими одитори.</p>
    <p class="indent"><strong>Във връзка с влязлото в сила изменение от 12.08.2016 на Наредба N 2 на Комисията за
      Финансов Надзор и по повод на чл. 43 а, ал 4, ви уведомяваме, че избраната от нас агенция за разпространение за
      регулирана информация е Сервиз Финансови пазари ЕООД; като самата информация е достъпна на интернет адрес
      www.x3news.com</strong></p>
    <p class="indent">От тук можете да свалите най-новите ни финансови отчети:</p>

    <div class="bg-fafafa">

      <p>
        <a href="/static/files/financial_statements/2025/Междинен-доклад-за-дейността-3rd-2025.pdf"
           target="_blank">Междинен доклад за дейността Алкомет АД, гр. Шумен за 3-то тримесечие на 2025</a>
      </p>
      <p>
        <a href="/static/files/financial_statements/2025/Междинен-доклад-за-дейността-за 2-ро-тримесечие-на-2025.pdf"
           target="_blank">Междинен доклад за дейността, Aлкомет АД, гр. Шумен за 2-ро тримесечие на 2025</a>
      </p>
      <p>
        <a href="/static/files/financial_statements/2025/Междинен-консолидиран-доклад-за-дейността-за-2-ро-тримесечие-на-2025.pdf"
           target="_blank">Междинен консолидиран доклад за дейността, Aлкомет АД, гр. Шумен за 2-ро тримесечие на 2025 </a>
      </p>


      <p>
        <a href="/static/files/financial_statements/2025/Междинен-доклад-за-дейността-Aлкомет-АД-030625.pdf"
           target="_blank">Междинен доклад за дейността, Aлкомет АД, гр. Шумен за 1-во тримесечие на 2025</a>
      </p>
      <p>
        <a href="/static/files/financial_statements/2025/Междинен-консолидиран-доклад-за-дейността-Aлкомет-АД-030625.pdf" target="_blank">Междинен консолидиран доклад за дейността, Aлкомет АД, гр. Шумен за 1-во тримесечие на 2025 </a>
      </p>

    </div>

    <p>
      <a href="/static/files/financial_statements/2025/Alcomet-AD-Consolidated-FS-2024-030625.pdf"
         target="_blank">Годишен консолидиран отчет за 2024г.</a>
    </p>
  <p>
    <a href="/static/files/financial_statements/2025/Годишен-финансов-отчет-за-2024.pdf"
       target="_blank">Годишен финансов отчет за 2024г.</a>
  </p>
    <p>
      <a href="/static/files/financial_statements/2024/Годишен-консолдиран-финансов-отчет-за-2023 .pdf"
         target="_blank">Годишен консолидиран отчет за 2023г.</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/2024/годишен-финансов-отчет-2022.pdf"
         target="_blank">Годишен  финансов отчет за 2023г.</a>
    </p>

    <p>
      <a href="/static/files/financial_statements/2024/Годишен-консолидиран-финансов-отчет-за-2022.pdf"
         target="_blank">Годишен консолидиран отчет за 2022г.</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/2023/годишен-финансов-отчет-2022.pdf"
         target="_blank">Годишен  финансов отчет за 2022г.</a>
    </p>

    <p>
      <a href="/static/files/financial_statements/2022/годишен-консолидиран-финансов-отчет-2021.pdf"
         target="_blank">Годишен  консолидиран финансов отчет за 2021г.</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/2022/годишен-финансов-отчет-2021.pdf"
         target="_blank">Годишен  финансов отчет за 2021г.</a>
    </p>

    <p>
      <a href="/static/files/financial_statements/17122021/alcomet-consolidated-fs-2020.pdf"
         target="_blank">Годишен консолидиран финансов отчет за 2020г.</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/17122021/alcomet-separate-fs-2020.pdf" target="_blank">Годишен финансов отчет за
        2020-та година</a>
    </p>

    <p>
      <a href="/static/files/reports/Alcomet-AD-2019-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2019-та година</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/09072020/Alcomet-заверен-финансов-отчет-2019.pdf" target="_blank">Годишен
        консолидиран доклад за дейността за 2019-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2018-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2018-та година</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/09072020/Alcomet-годишен-консолидиран-доклад-2018.pdf"
         target="_blank">Годишен консолидиран доклад за дейността за 2018-та година</a>
    </p>

    <p>
      <a href="/static/files/reports/Alcomet-AD-2017-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2017-та година</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/09072020/Alcomet-годишен-консолидиран-доклад-2017.pdf"
         target="_blank">Годишен консолидиран доклад за дейността за 2017-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2016-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2016-та година</a>
    </p>
    <p>
      <a href="/static/files/financial_statements/09072020/Alcomet-годишен-консолидиран-доклад-2016.pdf"
         target="_blank">Годишен консолидиран доклад за дейността за 2016-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2015-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2015-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2014-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2014-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2013-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2013-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2012-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2012-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2011-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2011-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2010-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2010-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2009-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2009-та година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2008-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2008-ма година</a>
    </p>
    <p>
      <a href="/static/files/reports/Alcomet-AD-2007-Financial-statements.pdf" target="_blank">Годишен финансов отчет за
        2007-ма година</a>
    </p>


    <app-share-button></app-share-button>
  </div>
</template>

<script>
  import ShareButton from "../shared/ShareButton";

  export default {
    components: {
      appShareButton: ShareButton
    }
  };
</script>

<style scoped>
  .investors-fs  p {
    font-size: 19px;
    line-height: 32px;
    margin: 15px auto;
    text-align: justify;
    width: 60%;
  }

  .bg-fafafa {
    background-color: #fafafa;
    padding: 25px;
    margin: 30px auto;
    width: 80%;
  }

  a {
    text-decoration: underline;
  }

  @media screen and (max-width: 1000px) {
    .investors-fs  p {
      font-size: 16px;
      margin: 15px 0;
      padding: 0 30px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/investors/FinancialStatements.vue